export const angularAlexMapDirectiveTemplate = {
    template: `
        <div class="alex-map-angular">
            <div class="map-container" ng-cloack>
                <div class="the-map" ng-if="map">
                    <al-map class="map-canvas" id="insectDamageReportMap" al-center="map.pos" 
                                al-layer-preset="map.activePresets">

                        <al-layer layer-name="Barkborre-rapporter">
                            <al-feature ng-repeat="p in points track by $index"
                                        geometry-type="Point" al-model="p"
                                        al-style="p.styleIndex >= 0 ? pointStyles[p.styleIndex] : null"
                                        label="{{p.name + '\n'}}{{localizations.quantity}}: {{p.quantity}}">
                            </al-feature>
                        </al-layer>

                        <al-control-container position="top-right">
                            <al-control title="{{localizations.controlTitles.layers}}" al-click="sidebarRight(true)">
                                <i class="material-icons md-24">layers</i>
                            </al-control>
                            <al-control title="{{localizations.controlTitles.fullscreen}}" ng-click="fullscreen(true)"
                                        ng-hide="map.isFullScreen">
                                <span class="material-icons md-24">fullscreen</span>
                            </al-control>
                            <al-control title="{{localizations.controlTitles.quitFullscreen}}"
                                        ng-click="fullscreen(false)"
                                        ng-show="map.isFullScreen">
                                <span class="material-icons md-24">fullscreen_exit</span>
                            </al-control>
                        </al-control-container>


                        <al-control-container position="bottom-right">
                            <!-- <al-tools-control></al-tools-control> -->
                            <!--<al-measurement-control></al-measurement-control>-->
                            <al-geolocate-control></al-geolocate-control>
                            <al-zoom-control></al-zoom-control>
                            <!--<al-print-control></al-print-control>-->
                        </al-control-container>
                    </al-map>
                    
                    <div class="map-sidebar is-right">
                        <header class="map-sidebar_header">
                            <h4 class="map-sidebar_heading">{{localizations.sidebarRight.showOnMap}}</h4>
                            <a class="map-sidebar_close" ng-click="sidebarRight(false)"></a>
                        </header>
                        <div class="map-sidebar_content">
                        <al-layer-sidebar active-presets="map.activePresets"
                                            base-presets="map.basePresets"
                                            addon-presets="map.addonPresets"
                                            vector-layers="map.vectorLayers">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
};